module.exports = __webpack_public_path__ + "static/img/robot.8a48762b.png";